<template>
    <div class="community">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-12">
                    <div class="content-sm">
                        <SectionHeader
                            :title="title"/>   
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="" data-name="slider-navigations" id="feedback-previous-arrow-landing">
                                <Icon :icon="iconPrev" class="swiper-button landing-slider-button-prev"/>
                            </div>
                                <swiper class="swiper" :options="swiperOption">
                                    <swiper-slide 
                                        v-for="(item, index) in sliderData" 
                                        :key="index"
                                        :id="`feedback-component-landing-slider-${index}`">
                                            <div data-name="slider-item">
                                                <img :src="item.photo"/>
                                                <p :class="{'mb-0': external && item.title}" data-name="name">
                                                    {{item.name}}
                                                </p>
                                                <div>
                                                    <p :class="{'small-gap': external && item.title}" data-name="title">
                                                        {{item.title}}
                                                    </p>
                                                    <p :id="`feedback-component-landing-${index}`" data-name="desc">
                                                        {{item.desc}}
                                                    </p>
                                                </div>
                                            </div>
                                    </swiper-slide>
                                    <div class="swiper-pagination" slot="pagination" />
                                </swiper>
                            <div class="" data-name="slider-navigations" id="feedback-next-arrow-landing">
                                <Icon :icon="iconNext" class="swiper-button landing-slider-button-next"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SectionHeader from '../SectionHeader'
import Icon from '@/components/Theme/Icon'
import {communityData, creatorsData} from '../landingPageData'
import initSwiperOptions from '../swiper.options'
import { computed, ref } from '@vue/composition-api'
export default {
    name: 'Community',
    components: {
        SectionHeader,
        Icon
    },
    props: {
        external: {
            type: Boolean,
            default: () => false
        },
        externalTitle: String,
        iconPrev: {
            type: String,
            default: 'landing-slider-prev'
        },
        iconNext: {
            type: String,
            default: 'landing-slider-prev'
        },
        pagination: {
            type: Object,
            default: () => null
        }
    },
    setup: function(props) {
        const slidesPerView = 1
        const breakpoints = false
        const externalUsage = ref(props.external)
        const mainTitle = 'What Our Community Members Say'
        const { swiperOption } = initSwiperOptions(slidesPerView, breakpoints, props.pagination, 10000)
        const sliderData = computed(() => externalUsage.value ? creatorsData: communityData)
        const title = computed(() => externalUsage.value ? props.externalTitle: mainTitle)
        return {
            swiperOption,
            sliderData,
            title
        }
    }
}
</script>

<style lang="scss" scoped>
$mob_name_padding: 24px;
$mob_title_padding: 8px;
$mob_name_size: 23px;
$mob_title_size: 16px;
$mob_title_lineheight: 24px;
$mob_desc_size: 16px;
$mob_desc_lineheight: 24px;
$mob_img_size: 124px;
$mob_name_lineheight: 31px;
.community {
    padding-top: 113px;
    padding-bottom: 103px;
    background: #F4F7FA;
    div.swiper-slide {
        background: transparent !important;
    }
    div[data-name="slider-navigations"] {
        img {
            cursor: pointer;
            min-width: 48px;
            filter: grayscale(1);
            transition: all 0.1s ease;
            &:hover {
                filter: none;
            }
            &:focus {
                outline: 0;
                border: 0;
            }
            &.landing-slider-button-next {
                transform: rotate(180deg);
            }
        }
    }
    div[data-name="slider-item"] {
        width: 100%;
        padding: 0 168px 0 168px;
        text-align: center;
        img {
            width: 194px;
            height: 194px;
            border-radius: 50%;
            object-fit: cover;
        }
        p {
            &[data-name="name"] {
                font-size: 27px;
                font-family: 'EinaBold';
                line-height: 35px;
                margin-top: 24px;
            }
            &[data-name="title"] {
                font-size: 18px;
                font-family: 'EinaBold';
                line-height: 25px;
                margin-top: 32px;
                &.small-gap {
                    margin-top: 8px;
                }
            }
            &[data-name="desc"] {
                font-size: 18px;
                line-height: 28px;
            }
        }
    }
}
@media (max-width: 767px) {
div.community {
    padding-top: 48px !important;
    padding-bottom: 56px;
    div[data-name="slider-navigations"] {
        img {
            min-width: 32px;
            width: 32px;
            // &:last-child {
            //     margin-left: 88px;
            // }
        }
    }
    div[data-name="slider-item"] {
        padding: 0;
        img {
            width: $mob_img_size;
            height: $mob_img_size;
        }
        p {
            &[data-name="name"] {
                font-size: $mob_name_size;
                font-family: 'EinaBold';
                line-height: $mob_name_lineheight;
                margin-top: $mob_name_padding;
            }
            &[data-name="title"] {
                font-size: $mob_title_size;
                font-family: 'EinaBold';
                line-height: $mob_title_lineheight;
                margin-top: $mob_title_padding;
            }
            &[data-name="desc"] {
                font-size: $mob_desc_size;
                line-height: $mob_desc_lineheight;
            }
        }
    }

}
}
</style>